import { useState, useEffect, useCallback } from "react";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";


const useRemarks = (moduledetails) => {
  const [remarkOptions, setRemarkOptions] = useState([]);
  const [loadingRemarks, setLoadingRemarks] = useState(false);
  const [moduleId, setModuleId] = useState(null);
  const [parentModuleId, setParentModuleId] = useState(null);

  const fetchRemarks = useCallback(async () => {
    if (!moduledetails) return;

    setLoadingRemarks(true);

    const params = {
      p_companyid: localStorage.getItem("companyid"),
      module_id: moduledetails.module_id,
      parent_module_id: moduledetails.parent_module_id,
    };

    try {
      const data = await callApi(
        API_ENDPOINTS.MASTER_GET_REMARKS,
        "POST",
        { "Content-Type": "application/json" },
        params
      );

      if (data && Array.isArray(data)) {
        setRemarkOptions(data);
      } else {
        setRemarkOptions([]);
      }

      setParentModuleId(moduledetails.parent_module_id);
      setModuleId(moduledetails.module_id);
    } catch (err) {
      console.error("Failed to load remarks", err);
      setRemarkOptions([]);
    } finally {
      setLoadingRemarks(false);
    }
  }, [moduledetails]);

  useEffect(() => {
    fetchRemarks();
  }, [fetchRemarks]);

  return {
    remarkOptions,
    loadingRemarks,
    moduleId,
    parentModuleId,
    refetchRemarks: fetchRemarks, // exposed if you need manual refresh    
  };
};

export default useRemarks;
